<div
  class="attribute-editor-component"
  rvSpinner="media-loader"
  [rvShowSpinner]="stockLibraryService.loading"
>
  <basic-uploader
    [uploaderId]="folderUploaderId + '-uploader'"
    [uploadManager]="storageUploadManager"
    [validType]="folderType"
    [shown]="isUploading"
  >
  </basic-uploader>
  <basic-uploader
    [uploaderId]="fileUploaderId + '-uploader'"
    [uploadManager]="storageUploadManager"
    [validType]="fileType"
    [shown]="isUploading"
  >
  </basic-uploader>
  <!-- default view -->
  <div class="attribute-editor-component" [shown]="!isUploading">
    <div class="attribute-editor-row">
      @if (stockLibrary) {
        <button
          rv-button
          variant="secondary"
          class="media-selector-button tw-w-full"
          (click)="
            stockLibraryService.showStockLibrary('image', boundAddFile, true)
          "
        >
          Stock Image Library
        </button>
        <button
          rv-button
          variant="secondary"
          class="media-selector-button tw-w-full mt-4"
          (click)="
            stockLibraryService.showStockLibrary('video', boundAddFile, true)
          "
        >
          Stock Video Library
        </button>
      } @else {
        @if (canUploadFiles()) {
          <div>
            <button
              rv-button
              [variant]="isImage ? 'primary' : 'secondary'"
              id="upload-file-unsubscribed"
              class="media-selector-button tw-w-full"
              (click)="currentPlanService.showUnlockThisFeatureModal()"
              [hidden]="currentPlanService.isPlanActive()"
            >
              {{ uploadFileLabel }}
            </button>
            <button
              rv-button
              [variant]="isImage ? 'primary' : 'secondary'"
              (click)="activateUploader('file')"
              id="{{ fileUploaderId }}-uploader-label"
              class="media-selector-button tw-w-full"
              [disabled]="isUploading"
              [shown]="currentPlanService.isPlanActive()"
            >
              {{ uploadFileLabel }}
            </button>
          </div>
        }
        @if (canUploadFolder()) {
          <div class="mt-3">
            <button
              rv-button
              variant="secondary"
              id="upload-folder-unsubscribed"
              class="media-selector-button tw-w-full"
              (click)="currentPlanService.showUnlockThisFeatureModal()"
              [hidden]="currentPlanService.isPlanActive()"
            >
              Upload Folder
            </button>
            <button
              rv-button
              variant="secondary"
              (click)="activateUploader('folder')"
              id="{{ folderUploaderId }}-uploader-label"
              class="media-selector-button tw-w-full"
              [disabled]="isUploading"
              [shown]="currentPlanService.isPlanActive()"
            >
              Upload Folder
            </button>
          </div>
        }
        <button
          rv-button
          variant="secondary"
          id="te-media-select"
          class="media-selector-button tw-w-full mt-4"
          [disabled]="isUploading"
          (click)="selectFromStorage()"
        >
          Select from Storage
        </button>
        @if (isImage || isVideo) {
          <button
            rv-button
            variant="secondary"
            class="media-selector-button tw-w-full mt-4"
            (click)="
              stockLibraryService.showStockLibrary(fileType, boundAddFile, true)
            "
            [disabled]="!featuresService.isFeatureAvailable('asset_library')"
          >
            Select from Stock
            @if (isImage) {
              Image
            } @else {
              Video
            }
            Library
            @if (!featuresService.isFeatureAvailable('asset_library')) {
              <upgrade-notice feature="asset_library"></upgrade-notice>
            }
          </button>
        }
        @if (isImage && canGenerateWithAI()) {
          <button
            rv-button
            variant="secondary"
            id="te-media-generate-ai"
            class="tw-w-full mt-4"
            (click)="generateWithAI()"
          >
            <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
            <span>Generate with AI</span>
          </button>
        }
      }
    </div>
  </div>
</div>
